import { ILocationService, ILocationsQueryParameters } from '../@posturinn/client-react';
import {
	FETCH_LOCATIONS_FAILED,
	FETCH_LOCATIONS_FULFILLED,
	FETCH_LOCATIONS_PENDING,
} from '../constants/actions/locationsActions';

export const fetchLocationsPending = () => ({
	type: FETCH_LOCATIONS_PENDING,
	payload: null,
});

export const fetchLocationsFulfilled = locations => ({
	type: FETCH_LOCATIONS_FULFILLED,
	payload: {
		locations,
	},
});

export const fetchLocationsFailed = error => ({
	type: FETCH_LOCATIONS_FAILED,
	payload: {
		error,
	},
});

export const fetchLocations = () => {
	return async function (dispatch, getState) {
		dispatch(fetchLocationsPending());
		const { injector } = getState().mobizReducer;
		const locationsService: ILocationService = injector.get(ILocationService);
		const query: ILocationsQueryParameters = null;
		try {
			locationsService.getLocations(query).subscribe({
				next: res => {
					dispatch(fetchLocationsFulfilled(res));
				},
				error: err => {
					dispatch(fetchLocationsFailed(err));
				},
			});
		} catch (error) {
			dispatch(fetchLocationsFailed(error));
		}
	};
};
